import styled from 'styled-components';

export const StyledIcon = styled.svg`
  // width: 24px;
  // height: 24px;
`;